import type { UseFormRegister, FieldErrors } from 'react-hook-form';
import type { SubscribeFormValues } from '../SubscribeFormSchema';
import { CONSENT_DIRECT_MARKETING_TEXT, CONSENT_NEWSLETTER_TEXT, getRulesPdfPath } from '../../../config/defaults';

interface Props {
  register: UseFormRegister<SubscribeFormValues>;
  errors: FieldErrors<SubscribeFormValues>;
  rulesPdf?: string | null;
  rulesOnly?: boolean;
}

/** The 3 standard newsletter consent checkboxes — rendered as a group, or not at all (disableAgrees).
 *  When rulesOnly is true, only the agreeRules checkbox is shown (e.g. SMS-only campaigns). */
export default function ConsentFields({ register, errors, rulesPdf, rulesOnly }: Props) {
  return (
    <>
      {!rulesOnly && (
        <>
          <div className="form-row">
            <div className="form-checkbox">
              <input id="subscribe_agreeNewsletter" type="checkbox" {...register('agreeNewsletter')} />
              <label htmlFor="subscribe_agreeNewsletter">
                {CONSENT_NEWSLETTER_TEXT}
                {errors.agreeNewsletter && <div className="form-error">{errors.agreeNewsletter.message}</div>}
              </label>
            </div>
          </div>
          <div className="form-row">
            <div className="form-checkbox">
              <input id="subscribe_agreeDirectMarketing" type="checkbox" {...register('agreeDirectMarketing')} />
              <label htmlFor="subscribe_agreeDirectMarketing">
                {CONSENT_DIRECT_MARKETING_TEXT}
                {errors.agreeDirectMarketing && (
                  <div className="form-error">{errors.agreeDirectMarketing.message}</div>
                )}
              </label>
            </div>
          </div>
        </>
      )}
      <div className="form-row">
        <div className="form-checkbox">
          <input id="subscribe_agreeRules" type="checkbox" {...register('agreeRules')} />
          <label htmlFor="subscribe_agreeRules">
            Akceptuję{' '}
            <a href={getRulesPdfPath(rulesPdf)} target="_blank" rel="noreferrer">
              regulamin
            </a>
            *{errors.agreeRules && <div className="form-error">{errors.agreeRules.message}</div>}
          </label>
        </div>
      </div>
    </>
  );
}
